module.exports = __webpack_public_path__ + "img/bg_rstj.76119da6.png";